import clsx from "clsx";
import styles from "@/pages/home/components/news-list/styles.scss";
import { FC } from "react";
import { format } from "date-fns";
import { isValid } from "date-fns/isValid";
import { NEWS_DATE_FORMAT, NO_VALUE } from "@/constants";
import { NewsListItemProps } from "@/pages/home/components/news-list/types";
import resetStyles from "@/scss/reset.scss";

export const NewsListItem: FC<NewsListItemProps> = ({
  StartDate,
  Title,
  ContentE,
  Urgency,
}) => {
  return (
    <li className={clsx(styles.newsItem, Urgency && styles.active)}>
      <div className={styles.itemDate}>
        {isValid(new Date(StartDate))
          ? format(new Date(StartDate), NEWS_DATE_FORMAT)
          : NO_VALUE}
      </div>
      <h3 className={styles.itemTitle}>{Title}</h3>
      <div
        className={clsx(styles.newsItemDescription, resetStyles.defaultUi)}
        dangerouslySetInnerHTML={{ __html: ContentE }}
      />
    </li>
  );
};
